
import { required } from 'vuelidate/lib/validators'

export default {
  dependent: {
    name: {
      required
    },
    birthdate: {
      required
    },
    kinship_id: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/dependents/resources/validations.js